import { useRouter } from "next/router";
import ErrorPage from "next/error";
import Container from "../../../components/blogComponents/container";
import PostBody from "../../../components/blogComponents/post-body";
import Header from "../../../components/blogComponents/header";
import ZoraHeader from "../../../components/organisms/ZoraHeader";
import data from "../../../zoraData";
import PostHeader from "../../../components/blogComponents/post-header";
// import Layout from "../../../components/blogComponents/layout";
import { getPostBySlug, getAllPosts } from "../../../lib/api";
import PostTitle from "../../../components/blogComponents/post-title";
import Head from "next/head";
import { CMS_NAME } from "../../../lib/constants";
import markdownToHtml from "../../../lib/markdownToHtml";
import { useState } from "react";
import { Box } from "@chakra-ui/layout";
import PostDetailsHero from "../../../components/article/postDetailshHero";
import ArticleBody from "../../../components/article/articleBody";
import Layout from "../../../components/templates/Layout";

export default function Post({ post, morePosts, preview }) {
  const router = useRouter();
  const [draywerToggler, setDraywerToggler] = useState(false);
  const drawwyerHandler = (drawyerStatus) => {
    let body = document.body;
    setDraywerToggler(drawyerStatus);
    if (drawyerStatus) {
      body.classList.add("overflow");
    } else {
      body.classList.remove("overflow");
    }
  };
  if (!router.isFallback && !post?.slug) {
    return <ErrorPage statusCode={404} />;
  }
  return (
    <Layout>
      <Container>
        {/* <Header /> */}
        {router.isFallback ? (
          <PostTitle>Loading…</PostTitle>
        ) : (
          <article>
            <Head>
              <title>{post.title}</title>
              <meta name="description" content={`${post?.excerpt}`} />
              <meta
                name="keywords"
                content="Beauty salon, Montreal, hairstyles, colorists, makeup, nails, tattoo"
              />
              <meta name="og:description" content={`${post?.description}`} />
              <meta property="og:title" content={post?.title} />
              <meta property="og:type" content="article" />
              <meta property="og:url" content={"https://coverclap.com/blog/"+post?.slug} />
              <meta
                property="og:image"
                content={
                  post?.ogImage.url?.length > 2 ? "https://coverclap.com"+post?.ogImage?.url : "https://coverclap.com"+post?.coverImage
                }
              />
            </Head>
            <Box>
              <PostDetailsHero
                post={post}
                author={post.author}
                date={post.date.toISOString()}
                title={post.title}
                coverImage={post.coverImage}
              />
            </Box>
            <Box>
              <ArticleBody
                post={post}
                title={post.title}
                coverImage={post.coverImage}
                date={post.date.toISOString()}
                author={post.author}
              />
            </Box>
          </article>
        )}
      </Container>
    </Layout>
  );
}

export async function getStaticProps({ params }) {
  const post = getPostBySlug(params.category, [
    "title",
    "date",
    "slug",
    "author",
    "excerpt",
    "content",
    "ogImage",
    "coverImage",
    "description",
  ]);
  const content = await markdownToHtml(post.content || "");

  return {
    props: {
      post: {
        ...post,
        content,
      },
    },
  };
}
export async function getStaticPaths() {
  const posts = getAllPosts(["slug", "category"]);
  return {
    paths: posts?.map((post) => {
      return {
        params: {
          category: post?.slug,
        },
      };
    }),
    fallback: false,
  };
}
